import { useRef, useState } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { useMutation } from '@apollo/client';

import { IDigitalAddress } from '../../../types/contact';
import { notifySuccess } from '../../../services/notification';
import { CancelIcon, SaveIcon } from '../../common/icons';
import { GET_INDIVIDUAL_EMAILS, UPDATE_INDIVIDUAL_EMAIL } from '../../../graphql/contact-gql';
import IndividualDigitalAddressDetails, { IndividualEmailHandler } from './individual-digital-address-details';
import Button from '../../common/button';

type IndividualDigitalAddressUpdateProps = {
    digitalAddress?: IDigitalAddress;
    isOpen: boolean;
    toggle: () => void;
}

const IndividualDigitalAddressUpdate = (props: IndividualDigitalAddressUpdateProps) => {
    const {digitalAddress, isOpen, toggle} = props
    const [updateDigitalAddress] = useMutation(UPDATE_INDIVIDUAL_EMAIL)

    const [validated, setValidated] = useState<boolean>(true)
    const digitalAddressRef = useRef<IndividualEmailHandler>(null)

    const saveDigitalAddress = () => {
        setValidated(digitalAddressRef.current && digitalAddressRef.current.validate(true)||false);
        if (digitalAddressRef.current && !digitalAddressRef.current.validate(true)) {
            return
        }
        let emailInput = digitalAddressRef.current && digitalAddressRef.current.getEmail()
        updateDigitalAddress({
            variables: {
                individualId: digitalAddress?.businessEntityId,
                input: emailInput
            },
            refetchQueries: [{
                query: GET_INDIVIDUAL_EMAILS,
                variables: { individualId: digitalAddress?.businessEntityId }
            }],
            awaitRefetchQueries: true,
            onCompleted: (data) => {
                toggle()
                data && notifySuccess()
            }
        })
    }

    const onChange = () => {
        setValidated(!!digitalAddressRef.current?.validate(false))
    }

    return (
        <Modal size="lg" isOpen={isOpen} toggle={toggle} scrollable backdrop="static">
            <ModalHeader toggle={toggle}  tag={'h2'}>Update an Individual Email Address</ModalHeader>
            <ModalBody>
                <IndividualDigitalAddressDetails ref={digitalAddressRef} digitalAddress={digitalAddress}  onChange={onChange} ></IndividualDigitalAddressDetails>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={saveDigitalAddress}  disabled={!validated}><SaveIcon/> Update</Button>
                <Button color="secondary" onClick={toggle}><CancelIcon/> Cancel</Button>
            </ModalFooter>
        </Modal>
  )
}

export default IndividualDigitalAddressUpdate
